// extracted by mini-css-extract-plugin
module.exports = {"main-component":"executePopupWrongTick_main-component__2OEFe"};